import { useAuth0 } from "@equipmentshare/auth0-react";
import React from "react";
import { IdentityProvider } from "./IdentityProvider";
import {
  Auth0ApplicationConfigurationType,
  getAuth0ApplicationConfiguration,
} from "./Config";
import { NotAuthorized } from "./NotAuthorized";

export function AuthenticationRouter() {
  const {
    clientId,
    redirectUri,
  }: Auth0ApplicationConfigurationType = getAuth0ApplicationConfiguration();

  const auth0 = useAuth0();
  const { isAuthenticated, logout } = auth0;

  if (isAuthenticated) {
    return <IdentityProvider />;
  }

  logout({ client_id: clientId, returnTo: redirectUri });

  return <NotAuthorized />;
}
